import { Text } from '@risksmart-app/atomic-ui';

import type { RatingRowData, RatingSectionLang } from '../types';
import { RatingBadge } from './RatingBadge';

interface RatingRowProps {
  data: RatingRowData;
  lang: RatingSectionLang;
}

const RatingRow = ({ data, lang }: RatingRowProps) => {
  const { label, rating, formattedDate } = data;
  const hasRating = rating !== undefined;

  return (
    <div
      className={'rounded-md bg-neutral-minimal p-2.5 flex flex-col gap-1.5'}
    >
      <Text preset={'body-sm'} className={'font-semibold text-primary-hover'}>
        {label}
      </Text>
      {hasRating ? (
        <RatingBadge
          rating={rating}
          notRatedLabel={lang.notRatedBadge}
          className={'justify-center h-[27px] text-sm font-semibold'}
        />
      ) : (
        <RatingBadge
          rating={undefined}
          notRatedLabel={lang.noRatingScore}
          className={'justify-center h-[27px] text-sm font-semibold'}
          testId={'rating-row-no-rating'}
        />
      )}
      <Text
        preset={'body-sm'}
        className={'text-neutral-muted-foreground text-xs'}
        data-testid={'rating-row-date'}
      >
        {hasRating
          ? `${lang.resultDatePrefix} ${formattedDate ?? '-'}`
          : lang.noRatingAvailable}
      </Text>
    </div>
  );
};

export { RatingRow };
